import { Button, Pagination } from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";

export default function ContactUs() {
  const [data, setData] = useState([]);

  const [page, setPage] = useState(1);

  const getCreer = () => {
    axios
      .get(`${baseUrl}/blog/add-contact-us/`, {
        params: {
          page: page,
        },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setData(res?.data || []);
      })
      .catch(() => {
        toast.error("Failed to load contact data");
      });
  };

  const deleteFAQ = (id) => {
    axios
      .delete(`${baseUrl}/blog/add-contact-us/`, {
        data: { contactus_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        toast.success(res?.data?.message || "Deleted successfully");
        getCreer();
      })
      .catch(() => {
        toast.error("Error deleting contact");
      });
  };

  useEffect(() => {
    getCreer();
  }, [page]);

  return (
    <div className="w-full py-2">
      {/* Header */}
      <p className="mb-2 text-lg lg:text-2xl font-semibold text-center text-blue-900">
        Contact Us
      </p>

      <div className="overflow-x-auto bg-white border rounded shadow-sm">
        <table className="w-full text-xs border-collapse">
          <thead className="bg-blue-100">
            <tr className="leading-5">
              <th className="px-2 py-1 text-left border">Name</th>
              <th className="px-2 py-1 text-left border">Email</th>
              <th className="px-2 py-1 text-left border">Mobile</th>
              <th className="px-2 py-1 text-left border whitespace-nowrap">
                Date
              </th>
              <th className="px-2 py-1 text-center border">Action</th>
            </tr>
          </thead>

          <tbody>
            {data?.data?.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50 leading-5">
                <td className="px-2 py-1 border whitespace-nowrap">
                  {item.first_name} {item.last_name}
                </td>

                <td className="px-2 py-1 border break-all max-w-[180px]">
                  {item.email}
                </td>

                <td className="px-2 py-1 border whitespace-nowrap">
                  {item.mobile || "--"}
                </td>

                <td className="px-2 py-1 border whitespace-nowrap">
                  {moment(item.created_date).format("DD-MM-YYYY HH:mm")}
                </td>

                <td className="px-2 py-1 text-center border">
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    className="!text-xs !py-0 !min-h-[24px]"
                    onClick={() => deleteFAQ(item.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex items-center justify-end  p-2">
          <Pagination
            size="small"
            color="primary"
            count={data?.total_pages ?? 1}
            page={data?.current_page ?? 1}
            onChange={(_, value) => setPage(value)}
          />
        </div>
      </div>
    </div>
  );
}
